import { Chip, Grid } from "@mui/material"
import Box from "@mui/material/Box"
import NftVideo from "../NftVideo"
import { LinearProgressStyled } from "../BorderLinearProgress"
import { styled } from "@mui/material/styles"
import { useState } from "react"

const StyledChip = styled(Chip)(({ theme }) => ({
  padding: "2px 0",
  height: "auto",
  background: "rgba(0, 0, 0, .35)",
  "& > span": {
    fontSize: "16px",
  },
}))

export const NftCard = ({
  image,
  video,
  lvl,
  bonus,
  rarity,
  progressValue,
  progressLabel,
}) => {
  const [videoTrigger, setVideoTrigger] = useState(false)
  return (
    <Box
      className="img_toggler"
      onMouseEnter={() => setVideoTrigger(true)}
      onMouseLeave={() => setVideoTrigger(false)}
      sx={{ position: "relative" }}
    >
      <img src={image} alt="" className="img-static"></img>
      <NftVideo videoUrl={video} poster={image} videoTrigger={videoTrigger} />

      <Box
        textAlign="center"
        mt={1}
        sx={{
          width: "100%",
          position: "absolute",
          bottom: "8px",
          padding: "0 12px 12px",
        }}
      >
        <Grid container spacing={1}>
          {lvl && (
            <Grid item>
              <StyledChip label={`Level: ${lvl}`} />
            </Grid>
          )}

          {bonus && (
            <Grid item>
              <StyledChip label={`Bonus: ${bonus}`} />
            </Grid>
          )}

          {rarity && (
            <>
              <Grid item>
                <StyledChip label={rarity} />
              </Grid>

              <Grid item xs={12}>
                <LinearProgressStyled
                  value={progressValue}
                  label={progressLabel}
                  rarity={rarity}
                />
              </Grid>
            </>
          )}
        </Grid>
      </Box>
    </Box>
  )
}
